import http from "@/services/http";

export async function add(
  basketId: string,
  orderTotal: number,
  paymentMethod?: string
) {
  const { data } = await http().post(
    globalThis.env.API_COMMERCE + "/commerce/basket/payment-instrument",
    {
      basket: {
        basketId: basketId,
      },
      paymentInstrument: {
        amount: orderTotal,
        paymentMethodId: "VERIFONE",
      },
    }
  );
  return data;
}

export async function uploadTaxCertificate(formData: FormData) {
  const { data } = await http().post(
    globalThis.env.API_COMMERCE + "/commerce/tax-certificate",
    formData
  );
  return data;
}

export async function getCustomer() {
  const { data } = await http().get(
    globalThis.env.API_COMMERCE + "/commerce/customer"
  );
  return data;
}

export async function getCountrySpec(
  countryCode: string,
  sellingEntity: string
) {
  const { data } = await http().get(
    globalThis.env.API_COMMERCE +
      "/commerce/country-spec?countryCode=" +
      countryCode +
      "&sellingEntity=" +
      sellingEntity
  );
  return data;
}
